import UploadNewsForm from "../../UploadNewsForm";
import { createDeath } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewDeath() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createDeath(title, description, image);
      if (result) {
        navigate("/death/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"Deaths"}
          breadCrumbText={"Create New"}
          goBackLink={"/death/all"}
        />
      </Container>
    </>
  );
}
